import React, { useEffect, useState } from "react"
import Link from "../components/Link"
import { useKeenSlider } from "keen-slider/react"
import "../style/DiscoverByModule.css"
import "keen-slider/keen-slider.min.css"
import Text from "../components/Text"
import Icon from "../components/Icon"
import { getKeys } from "@src/utils/dictionary"
import Select from "../components/Select"
import { MenuItem } from "@material-ui/core"
import { GTMEvent } from "../utils/gtm"

const DiscoverByModule = props => {
  const { item, title, repo, moving_on } = props

  const [selectedChip, setSelectedChip] = useState("")
  const [chipElements, setChipElements] = useState([])
  const [originalProducts, setOriginalArrayOfProducts] = useState([])
  const [arrayOfProducts, setArrayOfProducts] = useState([])
  const [reload, setReload] = useState(true)
  const [wrapper, setWrapper] = useState(0)
  const [selectedChipSelect, setSelectedChipSelect] = useState(0)

  const sliderAnimation = { duration: 10000, easing: t => t }

  const THRESHOLDS_ANIMATION = {
    400: 1.3,
    500: 1.5,
    600: 1.8,
    700: 2,
    800: 2.3,
    900: 2.8,
    1000: 3,
    1200: 3.5,
    1350: 4,
    1500: 4.5,
    1600: 5,
    1700: 5.3,
    1800: 5.5,
    1900: 6,
    5000: 6,
  }

  const compareSizeWithThreeSholds = myArray => {
    const thresholds = Object.keys(THRESHOLDS_ANIMATION)
      .map(el => parseInt(el))
      .sort((a, b) => a - b)
    const index = thresholds.findIndex(th => {
      return th >= window.innerWidth
    })
    const key = thresholds[index]
    return myArray.length > THRESHOLDS_ANIMATION[key]
  }

  // set delle opzioni dello slider
  const setSliderOptions = () => ({
    loop: true,
    renderMode: "precision",
    drag: true,
    initial: 0,
    slides: {
      spacing: 30,
      perView: 4,
    },
    created(s) {
      if (moving_on?.field_value) {
        s.moveToIdx(1, true, sliderAnimation)
      }
    },
    updated(s) {
      if (moving_on?.field_value) {
        s.moveToIdx(s.track.details.abs + 1, true, sliderAnimation)
      }
    },
    animationEnded(s) {
      if (moving_on?.field_value) {
        s.moveToIdx(s.track.details.abs + 1, true, sliderAnimation)
      }
    },
    breakpoints: {
      "(min-width: 1900px)": {
        slides: {
          perView: 6.5,
          spacing: 30,
        },
      },
      "(max-width: 1900px)": {
        slides: {
          perView: 6,
          spacing: 30,
        },
      },
      "(max-width: 1800px)": {
        slides: {
          perView: 5.5,
          spacing: 30,
        },
      },
      "(max-width: 1700px)": {
        slides: {
          perView: 5.3,
          spacing: 30,
        },
      },
      "(max-width: 1600px)": {
        slides: {
          perView: 5,
          spacing: 30,
        },
      },
      "(max-width: 1500px)": {
        slides: {
          perView: 4.5,
          spacing: 30,
        },
      },
      "(max-width: 1350px)": {
        slides: {
          perView: 4,
          spacing: 30,
        },
      },
      "(max-width: 1200px)": {
        slides: {
          perView: 3.5,
          spacing: 30,
        },
      },
      "(max-width: 1000px)": {
        slides: {
          perView: 3,
          spacing: 30,
        },
      },
      "(max-width: 900px)": {
        slides: {
          perView: 2.8,
          spacing: 30,
        },
      },
      "(max-width: 800px)": {
        slides: {
          perView: 2.3,
          spacing: 30,
        },
      },
      "(max-width: 700px)": {
        slides: {
          perView: 2,
          spacing: 30,
        },
      },
      "(max-width: 600px)": {
        slides: {
          perView: 1.8,
          spacing: 30,
        },
        created() {},
        updated() {},
        animationEnded() {},
      },
      "(max-width: 500px)": {
        slides: {
          perView: 1.5,
          spacing: 30,
        },
        created() {},
        updated() {},
        animationEnded() {},
      },
      "(max-width: 400px)": {
        slides: {
          perView: 1.3,
          spacing: 30,
        },
        created() {},
        updated() {},
        animationEnded() {},
      },
    },
  })

  const sliderPlugin = slider => {
    let mouseOver
    let timeout
    const nextTimeout = () => {
      clearTimeout(timeout)
      if (mouseOver) {
        return
      }
      timeout = setTimeout(() => {
        if (!mouseOver && window.innerWidth > 600) {
          moving_on?.field_value &&
            slider.moveToIdx(
              slider.track && slider.track.details
                ? slider.track.details.abs + 1
                : 1,
              true,
              sliderAnimation
            )
        }
      }, 500)
    }
    slider.on("created", () => {
      moving_on?.field_value &&
        slider.container.addEventListener("mouseover", () => {
          mouseOver = true
          slider.animator.stop()
        })
      moving_on?.field_value &&
        slider.container.addEventListener("mouseout", () => {
          mouseOver = false
          nextTimeout()
        })
    })
  }

  /** useEffect per far ripartire lo slider dopo il reload */

  useEffect(() => {
    if (!reload) {
      setTimeout(() => {
        if (slider && slider.current && window.innerWidth > 600) {
          moving_on?.field_value &&
            slider.current.moveToIdx(
              slider.current.track && slider.current.track.details
                ? slider.current.track.details.abs + 1
                : 1,
              true,
              sliderAnimation
            )
        }
      }, 500)
    }
  }, [reload])

  useEffect(() => {
    async function fetchData() {
      getKeys({
        viewAll: "category.discover-by.all",
      }).then(res => {
        setWrapper(res)
        setSelectedChip(res?.viewAll)
        setChipElements(prev => [
          { value: res.viewAll, label: res.viewAll },
          ...prev,
        ])
      })
    }

    fetchData()
  }, [])

  useEffect(() => {
    if (item && item.field_value && item.field_value.length > 0) {
      const arrayChip = []
      const arrayProd = []

      item.field_value.forEach(internalItem => {
        if (
          internalItem.field_value &&
          internalItem.field_value.tag_name &&
          internalItem.field_value.tag_name.field_value &&
          internalItem.field_value.product &&
          internalItem.field_value.product.product_discover_by
        ) {
          let srcImage =
            internalItem.field_value?.product?.product_discover_by
              ?.list_box_v2_image_foreground || null
          let backgroundImage =
            internalItem.field_value?.product?.product_discover_by
              ?.list_box_v2_image_mobile || null

          internalItem.field_value.tag_name.field_value
            .split(",")
            .forEach(tag => {
              const element = arrayChip.find(el => el.value === tag.trim())
              if (!element) {
                arrayChip.push({
                  value: tag.trim(),
                  label: tag.trim(),
                })
              }
            })
          arrayProd.push({
            ...internalItem.field_value.product.product_discover_by,
            tag: internalItem.field_value.tag_name.field_value,
            scale: internalItem.field_value.product_scale.field_value,
            srcImage: internalItem?.field_value?.product_image?.field_value
              ? internalItem?.field_value?.product_image
              : srcImage,
            backgroundImage: internalItem?.field_value?.background_product_image
              ?.field_value
              ? internalItem?.field_value?.background_product_image
              : backgroundImage,
          })
        }
      })

      setOriginalArrayOfProducts(arrayProd)
      setArrayOfProducts(arrayProd)
      setChipElements(arrayChip)
    }
  }, [item])

  useEffect(() => {
    let arrayOfElements = [...originalProducts]
    setReload(true)
    if (selectedChip && selectedChip !== wrapper.viewAll) {
      arrayOfElements = arrayOfElements.filter(el =>
        el.tag.includes(selectedChip)
      )
      setArrayOfProducts(arrayOfElements)
    } else {
      setArrayOfProducts(originalProducts)
    }
    setTimeout(() => setReload(false), 2000)
  }, [selectedChip, originalProducts])

  const [sliderRef, slider] = useKeenSlider(setSliderOptions(), [sliderPlugin])

  return (
    <section className="DiscoverByModule">
      <div className="discover-by-title">{title?.field_value}</div>
      <div className="discover-by-chip-selector">
        {chipElements.map((el, i) => {
          return (
            <div
              key={i}
              className={`discover-by-chip ${
                selectedChip === el.value
                  ? "discover-by-chip-selected"
                  : "discover-by-chip-not-selected"
              }`}
              onClick={() => {
                if (selectedChip === el.value) {
                  setSelectedChip(null)
                } else {
                  setSelectedChip(el.value)
                  GTMEvent(repo, "home_discover-by", "click_button", el.value)
                }
              }}
            >
              {el.label}
            </div>
          )
        })}
      </div>
      <div className="discover-by-selector">
        <Select
          value={selectedChipSelect}
          onChange={event => {
            if (selectedChipSelect === event?.target?.value) {
              setSelectedChipSelect(null)
              setSelectedChip(null)
            } else {
              setSelectedChipSelect(event?.target?.value)
              setSelectedChip(chipElements[event?.target?.value].value)
              GTMEvent(repo, "home_discover-by", "click_button", event.value)
            }
          }}
          isDiscovery={true}
        >
          {chipElements.map((item, index) => {
            return (
              <MenuItem key={index} value={index}>
                {item?.label}
              </MenuItem>
            )
          })}
        </Select>
      </div>

      {arrayOfProducts &&
      arrayOfProducts.length > 0 &&
      compareSizeWithThreeSholds(arrayOfProducts) ? (
        <div className="carosel-container">
          {/** Caso sopra la soglia */}
          {!reload ? (
            <div ref={sliderRef} className="keen-slider carosel-slider">
              {arrayOfProducts.map((card, indx) => {
                return (
                  <Link
                    key={indx}
                    className="keen-slider__slide discover-by-slide"
                    href={card?.list_box_v2_cta?.field_value?.href}
                    onClick={e => {
                      e.stopPropagation()
                      GTMEvent(
                        repo,
                        "home_discover-by",
                        "click_button",
                        `cta_${card?.menu_title?.field_value}`
                      )
                    }}
                  >
                    <div className="discover-by-image-container">
                      <img
                        style={{
                          background:
                            "url(" +
                            card?.backgroundImage?.field_value?.src +
                            ")",
                        }}
                        className="discover-by-image discover-by-background"
                        src={card?.srcImage?.field_value?.src}
                      />
                      {card.scale && (
                        <div className="discover-by-scale-position">
                          <span className="discover-by-scale-content">
                            <span className="discover-by-scale-content-bold">
                              {card.scale.split(" ")[0]}
                            </span>
                            {card.scale.split(" ").length > 1 && (
                              <span>{card.scale.split(" ")[1]}</span>
                            )}
                          </span>
                        </div>
                      )}
                    </div>
                    <div className={`discovery-by-content`}>
                      <div>
                        <div className="discover-by-content-upTitle">
                          <Text
                            className="discovery-by-uptitle"
                            dangerouslySetInnerHTML={{
                              __html: card?.list_box_v2_up_title?.field_value,
                            }}
                          ></Text>
                        </div>
                        <h3 className="discovery-by-title">
                          {card?.list_box_v2_title?.field_value}
                        </h3>
                      </div>
                      <Link
                        href={card?.list_box_v2_cta?.field_value?.href}
                        className="discovery-by-cta"
                      >
                        <span>{card?.list_box_v2_cta?.field_value?.title}</span>
                        <Icon
                          className={"pack-card-arrow"}
                          name="right_orange"
                        />
                      </Link>
                    </div>
                  </Link>
                )
              })}
            </div>
          ) : (
            <div className="discover-by-loader" />
          )}
        </div>
      ) : !reload ? (
        <div className="carosel-no-slide">
          {arrayOfProducts &&
            arrayOfProducts.length > 0 &&
            arrayOfProducts.map((card, indx) => {
              return (
                <Link
                  key={indx}
                  className="keen-slider__slide discover-by-slide"
                  values={card?.list_box_v2_cta?.field_value?.href}
                  onClick={e => {
                    e.stopPropagation()
                    GTMEvent(
                      repo,
                      "home_discover-by",
                      "click_button",
                      `cta_${card?.menu_title?.field_value}`
                    )
                  }}
                >
                  <div className="discover-by-image-container">
                    <img
                      style={{
                        background:
                          "url(" +
                          card?.backgroundImage?.field_value?.src +
                          ")",
                      }}
                      className="discover-by-image discover-by-background"
                      src={card?.srcImage?.field_value?.src}
                    />
                    {card.scale && (
                      <div className="discover-by-scale-position">
                        <span className="discover-by-scale-content">
                          <span className="discover-by-scale-content-bold">
                            {card.scale.split(" ")[0]}
                          </span>
                          {card.scale.split(" ").length > 1 && (
                            <span>{card.scale.split(" ")[1]}</span>
                          )}
                        </span>
                      </div>
                    )}
                  </div>
                  <div className={`discovery-by-content `}>
                    <div>
                      {card &&
                        card?.list_box_v2_up_title &&
                        card?.list_box_v2_up_title?.field_value && (
                          <div className="discover-by-content-upTitle">
                            <Text
                              className="discovery-by-uptitle"
                              dangerouslySetInnerHTML={{
                                __html: card?.list_box_v2_up_title?.field_value,
                              }}
                            ></Text>
                          </div>
                        )}
                      <h3 className="discovery-by-title">
                        {card?.list_box_v2_title?.field_value}
                      </h3>
                    </div>
                    <Link
                      href={card?.list_box_v2_cta?.field_value?.href}
                      className="discovery-by-cta"
                    >
                      <span>{card?.list_box_v2_cta?.field_value?.title}</span>
                      <Icon className={"pack-card-arrow"} name="right_orange" />
                    </Link>
                  </div>
                </Link>
              )
            })}
        </div>
      ) : (
        <div className="discover-by-loader" />
      )}
      <div className="footer-content">
        <div className="footer-background" />
      </div>
    </section>
  )
}

export default DiscoverByModule
